<cb-dialog>
    <form class="flex-col flex" #form="ngForm">
        <span class="mat-subtitle-1">Select widgets to add to your dashboard</span>
        @for (item of availableWidgets; track item) {
            <cb-checkbox
                [label]="item.label"
                [name]="'widget' + item.id"
                [ngModel]="isWidgetSelected(item.id)"
                (change)="onWidgetChanged(item.id, $event)"
            ></cb-checkbox>
        }
        @if (!availableWidgets.length) {
            <div class="cb-margin no-widgets-message start-center flex-row">
                <mat-icon class="mat-accent">info_circle</mat-icon>
                <span class="cb-margin-left">You do not have any available widgets</span>
            </div>
        }
    </form>
    <div actions>
        <span class="flex"></span>
        <button mat-raised-button color="primary" [disabled]="!canSave()" (click)="onSaveClicked()">
            Add Widget
        </button>
        <button mat-raised-button (click)="dialogRef.close()">Close</button>
    </div>
</cb-dialog>
